import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appTouchHover]'
})
export class TouchHoverDirective {
  constructor(private el: ElementRef) {}

  @HostListener('touchstart', ['$event'])
  onTouchStart(): void {
    this.el.nativeElement.classList.add('hover');
  }

  @HostListener('touchend', ['$event'])
  onTouchEnd(): void {
    setTimeout(() => this.el.nativeElement.classList.remove('hover'), 300);
  }
}
